"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { identify, Provider, reset } from "@workspace/analytics-web";

import { authClient } from "~/lib/auth/client";

const isPublicPath = (pathname: string | null) => {
  if (!pathname) return true;
  return !/^\/[^/]+\/(dashboard|admin|auth)(\/|$)/.test(pathname);
};

const AuthedAnalyticsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const session = authClient.useSession();

  useEffect(() => {
    if (session.isPending) {
      return;
    }

    if (session.data?.user) {
      const { id, email, name } = session.data.user;
      identify(id, { email, name });
    } else {
      reset();
    }
  }, [session]);

  return <Provider>{children}</Provider>;
};

export const AnalyticsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const pathname = usePathname();

  if (isPublicPath(pathname)) {
    return <Provider>{children}</Provider>;
  }

  return <AuthedAnalyticsProvider>{children}</AuthedAnalyticsProvider>;
};
